import { extendMoment } from 'moment-range';
import momenttz from 'moment-timezone';

const moment = extendMoment(momenttz);
moment.locale('es');
moment.tz.setDefault('America/Bogota');

const CLOSED = 'closed';
// const OPEN = 'open';
const UNDEFINED = 'undefined';
const CLOSED_NOW = 'closedNow';
const OPEN_NOW = 'openNow';
const format = 'hh:mm a';

const getMoment = (time) => {
  const item = moment();
  const parts = time.split(':');
  item.hour(parseInt(parts[0]));
  item.minute(parseInt(parts[1]));
  return item;
};

const getRangesSummary = (schedules, locale = 'es') => {
  const summary = [];
  getDays().forEach((day) => {
    const daySchedule = schedules[day.value];
    let closed = true;
    let daySchedules = [CLOSED];
    if (daySchedule) {
      ({ schedules: daySchedules } = getRanges(daySchedule));
      closed = false;
    }
    // const name = t(`venues.days.${day.value}`);
    const name = day.label[locale];
    let index = -1;
    summary.some((item, i) => {
      const equals = JSON.stringify(item.schedules) === JSON.stringify(daySchedules);
      equals && (index = i);
      return equals;
    });
    if (index !== -1) {
      summary[index].name = `${summary[index].name} - ${name}`;
    } else {
      summary.push({
        name,
        schedules: daySchedules,
        closed,
      });
    }
  });
  return summary;
};

const getRanges = (daySchedule, time) => {
  let text = '';
  let open = false;
  const schedules = [];
  daySchedule.forEach((item) => {
    const start = getMoment(item.start);
    const end = getMoment(item.end);
    const range = moment.range(start, end);
    const tempText = `${start.format(format)} - ${end.format(format)}`;
    text = `${text}${tempText}\n`;
    schedules.push(tempText);
    if (!!time && range.contains(time)) {
      open = true;
    }
  });
  return {
    scheduleText: text.trim(),
    openText: open ? OPEN_NOW : CLOSED_NOW,
    schedules,
    open,
  };
};

const getScheduleByTime = (current, venue) => {
  const today = venue.schedule[current.day.toLowerCase()];
  if (!today) {
    return {
      open: false,
      openText: CLOSED_NOW,
    };
  }
  return getRanges(today, current.time);
};

const getCurrent = () => {
  const now = moment();
  now.locale('en');
  return {
    day: now.format('dddd'),
    time: now,
  };
};

// const DAYS = {
//   monday: 'Lunes',
//   tuesday: 'Martes',
//   wednesday: 'Miercoles',
//   thursday: 'Jueves',
//   friday: 'Viernes',
//   saturday: 'Sábados',
//   sunday: 'Domingos',
//   holiday: 'Festivos',
// };

const getDays = () => [
  { label: { es: 'Lunes', en: 'Mondays' }, value: 'monday' },
  { label: { es: 'Martes', en: 'Tuesdays' }, value: 'tuesday' },
  { label: { es: 'Miercoles', en: 'Wednesdays' }, value: 'wednesday' },
  { label: { es: 'Jueves', en: 'Thursdays' }, value: 'thursday' },
  { label: { es: 'Viernes', en: 'Fridays' }, value: 'friday' },
  { label: { es: 'Sábados', en: 'Saturdays' }, value: 'saturday' },
  { label: { es: 'Domingos', en: 'Sundays' }, value: 'sunday' },
  { label: { es: 'Festivos', en: 'Holidays' }, value: 'holiday' },
];

export {
  getScheduleByTime, getCurrent, getRanges, getDays, getRangesSummary,
  OPEN_NOW, CLOSED, CLOSED_NOW, UNDEFINED,
};
